import { ToastOptions, toast } from "react-toastify";
import { endPoints } from "../constants/config";

export function handleResponseError(error: any): void {
  try {
    if (error.response) {
      handleResponseStatus(error);
    } else {
      handleNetworkError(error);
    }
  } catch (e) {
    throw e;
  }
}

function handleResponseStatus(error: any): void {
  switch (error.response.status) {
    case 400:
    case 401:
    case 403:
    case 422:
      initToast(error);
      break;
    case 426:
      break;
    case 404:
    case 500:
      handleServerError(error);
      break;
    default:
      initToast(error);
  }
}

function handleServerError(error: any): void {
  console.log("error");
  if (error.config.url === endPoints.getAuthTokenApi) {
    return;
  }
  if (error.config.url === endPoints.pnTsnStatus) {
    throw error;
  }
  if (error.config.url !== endPoints.pnTsnStatus) {
    initToast(error);
  } else if (
    error.config.url === endPoints.INTERNATIONAL_TRANSFER ||
    error.config.url === endPoints.INTER_BANK_TRANSFER ||
    error.config.url === endPoints.OWN_ACCOUNT_TRANSFER ||
    error.config.url === endPoints.INTRA_BANK_TRANSFER
  ) {
    throw error;
  }
}

function handleNetworkError(error: any): void {
  if (error.message === "Network Error") {
    initToast(error);
  }
}

export const initToast = (error: any) => {
  const config: ToastOptions = {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: true,
    bodyClassName: "bg-black toast-body",
    theme: "dark",
  };
  if (typeof error === "string") {
    toast.error(error, config);
    return;
  }
  toast.error(
    error.response?.data?.error ||
      error.response?.data?.message ||
      error.message,
    config
  );
};
